module.exports = __webpack_public_path__ + "img/life@Q_appreciate.beb800eb.jpg";